import React, { useEffect, useMemo, useState } from 'react';
import Topbar from '../components/Topbar';
import Leftbar from '../components/Leftbar';
import { Link } from 'react-router-dom';
import { getAssessList } from '../Utils/utils';
import { toggleLoader } from '../actions/loader';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { Modal } from 'react-bootstrap';
import moment from 'moment';
import '../Gynac/style.css';

const Assessment = (props) => {
	const [users, setUsers] = useState([]);
	const [count, setCount] = useState(10);
	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(0);
	const [detailModal, setDetailModal] = useState(null);
	const [search, setSearch] = useState('');
	const [visitFilter, setVisitFilter] = useState('all');

	const getList = async (perPage = count, selectedPage = 1) => {
		props.toggleLoader(true);
		const res = await getAssessList(perPage, selectedPage);
		setTotal(res?.metadata?.totalPage);
		setPage(res?.metadata?.page);
		setUsers(res?.data || []);
		props.toggleLoader(false);
	};

	useEffect(() => {
		getList(count, 1);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const handlePageClick = async (e) => {
		const selectedPage = e.selected + 1;
		window.scroll({ top: 0, left: 0, behavior: 'smooth' });
		getList(count, selectedPage);
	};

	const handlePerPageChange = (e) => {
		const next = parseInt(e.target.value, 10);
		setCount(next);
		getList(next, 1);
	};

	const visitTypes = useMemo(() => {
		const set = new Set();
		(users || []).forEach(u => { if (u?.visit_type) set.add(u.visit_type); });
		return Array.from(set);
	}, [users]);

	const filteredUsers = useMemo(() => {
		const q = search.trim().toLowerCase();
		return (users || []).filter((u) => {
			if (visitFilter !== 'all' && (u?.visit_type || '') !== visitFilter) return false;
			if (!q) return true;
			const mother = (u?.mother_name || '').toLowerCase();
			const visit = (u?.visit_type || '').toLowerCase();
			const notes = (u?.visit_notes || '').toLowerCase();
			return mother.includes(q) || visit.includes(q) || notes.includes(q);
		});
	}, [users, search, visitFilter]);

	return (
		<div className="g-sidenav-show bg-gray-100">
			<div id="wrapper">
				<Leftbar />

				<main className="main-content border-radius-lg">
					<Topbar />
					<div className="header bg-primary pb-6">
						<div className="container-fluid">
							<div className="header-body">
								<div className="row align-items-center py-4">
									<div className="col-lg-6 col-7">
										<nav aria-label="breadcrumb" className="d-none d-md-inline-block ml-md-4">
											<ol className="breadcrumb breadcrumb-links breadcrumb-dark">
												<li className="breadcrumb-item"><Link to="/dashboard"><i className="fas fa-home" /></Link></li>
												<li className="breadcrumb-item"><a href="#">Assessment</a></li>
											</ol>
										</nav>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="container-fluid mt--6"></div>
					<div className="container-fluid">
						<div className="card gynac-card">
							<div className="gynac-card-header">
								<h3 className="gynac-title">
									Assessment Listing
									<span className="gynac-count-chip">
										{filteredUsers.length}{search || visitFilter !== 'all' ? ` of ${users.length}` : ''}
									</span>
								</h3>

								<div className="gynac-toolbar">
									<div className="gynac-search">
										<i className="fas fa-search search-icon" />
										<input
											type="text"
											placeholder="Search mother, visit, notes"
											value={search}
											onChange={(e) => setSearch(e.target.value)}
										/>
									</div>
									{visitTypes.length > 0 && (
										<div className="gynac-filter">
											<select value={visitFilter} onChange={(e) => setVisitFilter(e.target.value)}>
												<option value="all">All visit types</option>
												{visitTypes.map(v => <option key={v} value={v}>{v}</option>)}
											</select>
										</div>
									)}
								</div>
							</div>

							<div className="table-responsive">
								<table className="gynac-table">
									<colgroup>
										<col style={{ width: '20%' }} />
										<col style={{ width: '14%' }} />
										<col style={{ width: '30%' }} />
										<col style={{ width: '12%' }} />
										<col style={{ width: '10%' }} />
										<col style={{ width: '14%' }} />
									</colgroup>
									<thead>
										<tr>
											<th>Mother</th>
											<th>Visit Type</th>
											<th>Notes</th>
											<th>Blood Pressure</th>
											<th>Temp.</th>
											<th style={{ textAlign: 'center' }}>Date & Action</th>
										</tr>
									</thead>
									<tbody>
										{filteredUsers.map((user) => {
											const notes = user?.visit_notes || '';
											const isLong = notes.length > 100;

											return (
												<tr key={user?._id}>
													<td data-label="Mother">
														<div className="doctor-name">{user?.mother_name || '—'}</div>
													</td>
													<td data-label="Visit Type">
														<span className="cred-education" style={{ fontSize: '0.85rem', color: '#2d3148' }}>
															{user?.visit_type || '—'}
														</span>
													</td>
													<td data-label="Notes">
														{notes ? (
															<>
																<div className="desc-text">{notes}</div>
																{isLong && (
																	<span
																		className="desc-view-more"
																		onClick={() => setDetailModal({ title: 'Visit Notes', text: notes, subtitle: user?.mother_name })}
																	>
																		View More
																	</span>
																)}
															</>
														) : (
															<span className="text-muted">—</span>
														)}
													</td>
													<td data-label="BP">{user?.blood_pressure || '—'}</td>
													<td data-label="Temperature">{user?.temperature || '—'}</td>
													<td data-label="Date & Action" style={{ textAlign: 'center' }}>
														<div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'center' }}>
															<span style={{ fontSize: '0.78rem', color: '#6b7088' }}>
																{user?.date ? moment(user.date).format('DD MMM YYYY') : '—'}
															</span>
															<Link to={`/edit-assessment/${user?._id}`}>
																<button className="btn-pill btn-approve" style={{ width: 'auto', padding: '6px 16px' }}>
																	<i className="fas fa-eye" style={{ marginRight: 5, fontSize: '0.7rem' }} />
																	View
																</button>
															</Link>
														</div>
													</td>
												</tr>
											);
										})}
										{!filteredUsers.length && (
											<tr>
												<td colSpan={6}>
													<div className="gynac-empty">
														<i className="fas fa-clipboard-list" />
														<div className="gynac-empty-text">No assessments found</div>
													</div>
												</td>
											</tr>
										)}
									</tbody>
								</table>
							</div>

							{users.length > 0 && (
								<div className="gynac-footer">
									<div className="gynac-per-page">
										<span>Rows per page</span>
										<select value={count} onChange={handlePerPageChange}>
											<option value={10}>10</option>
											<option value={25}>25</option>
											<option value={50}>50</option>
										</select>
									</div>
									<div className="paginate-css" style={{ margin: 0 }}>
										<ReactPaginate
											previousLabel="<"
											nextLabel=">"
											breakLabel="..."
											pageCount={total}
											forcePage={page > 0 ? page - 1 : 0}
											marginPagesDisplayed={1}
											pageRangeDisplayed={3}
											onPageChange={handlePageClick}
											containerClassName="pagination"
											activeClassName="active"
										/>
									</div>
								</div>
							)}
						</div>
					</div>

					<Modal show={!!detailModal} onHide={() => setDetailModal(null)} centered>
						<Modal.Header style={{ borderBottom: '1px solid #e9ecef' }}>
							<div>
								<h5 className="mb-0" style={{ fontWeight: 700 }}>{detailModal?.title}</h5>
								{detailModal?.subtitle && <small className="text-muted">{detailModal.subtitle}</small>}
							</div>
							<button type="button" style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', lineHeight: 1 }} onClick={() => setDetailModal(null)}>&times;</button>
						</Modal.Header>
						<Modal.Body style={{ padding: '20px 24px', fontSize: '0.95rem', lineHeight: 1.7, color: '#333', maxHeight: '70vh', overflowY: 'auto' }}>
							{detailModal?.text}
						</Modal.Body>
					</Modal>
				</main>
			</div>
		</div>
	);
};

export default connect(null, { toggleLoader })(Assessment);
